var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(0.5)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8326 14.6679V9.33724C17.8326 8.98362 17.6921 8.64448 17.4421 8.39443C17.192 8.14438 16.8529 8.00391 16.4993 8.00391C16.1457 8.00391 15.8065 8.14438 15.5565 8.39443C15.3064 8.64448 15.166 8.98362 15.166 9.33724V14.6679H9.83529C9.48166 14.6679 9.14253 14.8084 8.89248 15.0584C8.64243 15.3085 8.50195 15.6476 8.50195 16.0012C8.50195 16.3549 8.64243 16.694 8.89248 16.944C9.14253 17.1941 9.48166 17.3346 9.83529 17.3346H15.166V22.6652C15.166 23.0189 15.3064 23.358 15.5565 23.608C15.8065 23.8581 16.1457 23.9986 16.4993 23.9986C16.8529 23.9986 17.192 23.8581 17.4421 23.608C17.6921 23.358 17.8326 23.0189 17.8326 22.6652V17.3346H23.1633C23.5169 17.3346 23.856 17.1941 24.1061 16.944C24.3561 16.694 24.4966 16.3549 24.4966 16.0012C24.4966 15.6476 24.3561 15.3085 24.1061 15.0584C23.856 14.8084 23.5169 14.6679 23.1633 14.6679H17.8326Z",
    fill: "#278B9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBig);
export default __webpack_public_path__ + "static/media/plusBig.61927aee3667dd397914d61862d74548.svg";
export { ForwardRef as ReactComponent };